import { PLCustomerData } from 'types/plCustomerData';
import { RelationApiFullResponse } from 'types/relations';

export const mapRelationApiResponseToPLCustomer = (
	response: RelationApiFullResponse
): PLCustomerData => ({
	initials: response.persoonlijkegegevens.voorletters,
	lastName: response.persoonlijkegegevens.achternaam,
	lastNamePrefix: response.persoonlijkegegevens.tussenvoegsel ?? '',
	gender: response.persoonlijkegegevens.geslacht === 'Vrouw' ? 'FEMALE' : 'MALE',
	birthdate: response.persoonlijkegegevens.geboortedatum
		? new Date(response.persoonlijkegegevens.geboortedatum).toISOString().split('T')[0]
		: '',
	postalCode: response.adresTelefoonnummer.postcode,
	street: response.adresTelefoonnummer.straat,
	houseNumber: response.adresTelefoonnummer.huisnummer,
	houseNumberSuffix: response.adresTelefoonnummer.huisnummerToevoeging ?? '',
	city: response.adresTelefoonnummer.woonplaats,
	phoneNumber: response.adresTelefoonnummer.mobielNummer,
	email: response.contactInformatie.emailadres,
	isMember:
		typeof response.lidmaatschap.typeLid === 'string' &&
		response.lidmaatschap.typeLid !== 'GEEN_LID',
	extraInformation: {
		email: '',
		birthdate: '',
		phoneNumber: '',
	},
});
